"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
var _react = _interopRequireDefault(require("react"));
var _inputSelect = require("@citrus/input-select");
var _PctyQuestionBuilder = require("./PctyQuestionBuilder.Common");
var _questionBuilder = require("@pcty/question-builder");
var _PctyQuestionBuilderEdit = _interopRequireDefault(require("./PctyQuestionBuilder.Edit.QuestionOptions"));
var Presentational = function Presentational(_ref) {
  var id = _ref.id,
    builderType = _ref.builderType,
    scenario = _ref.scenario,
    question = _ref.question,
    options = _ref.options,
    knockout = _ref.knockout,
    knockoutText = _ref.knockoutText,
    otherQuestion = _ref.otherQuestion,
    placeholder = _ref.placeholder,
    hint = _ref.hint,
    number = _ref.number,
    required = _ref.required,
    editable = _ref.editable,
    onQuestionUpdated = _ref.onQuestionUpdated;
  var questionTypeId = _questionBuilder.QUESTION_TYPE.dropdownList;
  var onQuestionTextUpdated = function onQuestionTextUpdated(questionText) {
    if (onQuestionUpdated) onQuestionUpdated({
      questionText: questionText
    });
  };
  var onOptionsUpdated = function onOptionsUpdated(edit) {
    var options = edit ? edit.options : [];
    if (onQuestionUpdated) onQuestionUpdated({
      options: options
    });
  };

  // setup our dummy edit container for the options' inline-editing
  var edit = {
    options: options,
    question: question,
    typeId: questionTypeId,
    otherQuestion: otherQuestion
  };
  var validationState = (0, _PctyQuestionBuilder.validate)(edit, true, builderType);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _PctyQuestionBuilder.renderHint)(id, hint), (0, _PctyQuestionBuilder.renderScenario)(id, scenario), (0, _PctyQuestionBuilder.renderQuestion)(id, questionTypeId, number, question, required, editable, onQuestionTextUpdated), (0, _PctyQuestionBuilder.renderKnockout)(id, knockout, knockoutText), editable ? /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilderEdit.default, {
    id: id,
    builderType: builderType,
    edit: edit,
    validationState: validationState,
    onOptionsChange: onOptionsUpdated
  }) : /*#__PURE__*/_react.default.createElement(_inputSelect.SelectStatic, {
    automationId: id,
    id: id,
    onChange: function onChange(selected) {
      return console.log(selected);
    },
    options: getListItems(id, otherQuestion, options),
    placeholder: placeholder
  }));
};
var getListItems = function getListItems(id, otherQuestion, options) {
  if (!options) return [];
  var retOptions = options.map(function (x) {
    return {
      label: x.value,
      value: x.value,
      id: x.id
    };
  });

  //add otherQuestion to the end of the list
  if (otherQuestion.enabled) {
    retOptions.push({
      label: otherQuestion.label,
      value: 'otherOption',
      id: otherQuestion.id
    });
  }
  return retOptions;
};
var _default = exports.default = Presentational;